import { render, staticRenderFns } from "./ShippingForm.vue?vue&type=template&id=a653d5da"
import script from "./ShippingForm.vue?vue&type=script&lang=ts"
export * from "./ShippingForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports